import { cn } from '../../common/functions/cn';
import useTestTag from '../../common/hooks/use-test-tag';

/** Shared with static name/value markup (e.g. a `dt`) that should look like a field label without being one. */
export const fieldLabelStyles = cn('block font-semibold text-sm');

interface FieldLabelProps {
  label: string;
  /** DOM id, for a control that has to name itself via `aria-labelledby`. */
  id?: string;
  name?: string;
  /** Extends the base styling. Conflicting utilities win over the base. */
  labelStyles?: string;
  /** For controls a `htmlFor` cannot target (e.g. contenteditable editors): focus the control on label click. */
  onClick?: () => void;
}

export default function FieldLabel({ label, id, name, labelStyles, onClick }: FieldLabelProps) {
  const tagCreator = useTestTag(label || '');

  return (
    <label
      id={id}
      className={cn(fieldLabelStyles, labelStyles)}
      htmlFor={name}
      onClick={onClick}
      ref={tagCreator('label')}
    >
      {label}
    </label>
  );
}
